import { css } from '@emotion/css'

import { spacing, fontSize, fontWeight, fontFamily, lineHeight } from '../../lib/styles'
import colors from '../../lib/themes/colors'

const styles = {
  wrapper: css({
    display: 'inline-flex',
    fontWeight: fontWeight.regular,
    fontSize: fontSize.small,
    fontFamily: fontFamily.body,
    lineHeight: lineHeight.default,
    color: colors.blackPearl,
    marginTop: spacing.small,
  }),
}

export default styles
